import { BadgeCheck, Loader2 } from 'lucide-react'
import { InfoPopover } from '@/components/ui/InfoPopover'
import type { AccessConfirmationIconButtonProps } from './AccessConfirmationIconButton.types'

export type { AccessConfirmationIconButtonProps } from './AccessConfirmationIconButton.types'

export function AccessConfirmationIconButton({
  onClick,
  busy = false,
  disabled = false,
  title = 'Access Confirmations',
  className = '',
  dataTestId,
}: AccessConfirmationIconButtonProps) {
  const isDisabled = disabled || busy

  return (
    <InfoPopover
      content={<p className="m-0 text-left font-medium text-slate-800">{title}</p>}
      align="center"
      maxWidth={360}
      testId={dataTestId ? `${dataTestId}-hint` : undefined}
    >
      <button
        type="button"
        onClick={onClick}
        disabled={isDisabled}
        aria-label={busy ? 'Opening access confirmations' : title}
        data-testid={dataTestId}
        className={`inline-flex items-center justify-center rounded-md border border-slate-200 p-1.5 text-[rgb(21_151_255)] hover:bg-blue-50 disabled:cursor-not-allowed disabled:opacity-60 ${className}`}
      >
        {busy ? (
          <Loader2 className="h-4 w-4 animate-spin" aria-hidden />
        ) : (
          <BadgeCheck className="h-4 w-4" aria-hidden />
        )}
      </button>
    </InfoPopover>
  )
}
